(function () {
  // wpm_38 — additive guard: clamp cart line qty to Flutter parity ceiling (6).
  // Liquid sets max on first paint; this covers typed input and + link edge cases.
  var CAP = 6;

  function cartLineInput(input) {
    if (!input || !input.matches('[data-line-key]')) return null;
    if (!input.closest('line-item-quantity')) return null;
    return input;
  }

  function effectiveMax(input) {
    var attr = input.getAttribute('max');
    if (attr) return Math.min(parseInt(attr, 10) || CAP, CAP);
    return CAP;
  }

  function clampInput(input) {
    var max = effectiveMax(input);
    if (!input.hasAttribute('max') || parseInt(input.getAttribute('max'), 10) > CAP) {
      input.setAttribute('max', String(max));
    }
    var val = parseInt(input.value, 10);
    if (!Number.isFinite(val) || val <= max) return false;
    input.value = String(max);
    return true;
  }

  function clampCartLineInputs(root) {
    (root || document).querySelectorAll('line-item-quantity [data-line-key]').forEach(function (input) {
      if (cartLineInput(input)) clampInput(input);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('line-item-quantity a[href*="/cart/change"]');
      if (!link) return;
      var url;
      try {
        url = new URL(link.href);
      } catch (e) {
        return;
      }
      var qty = parseInt(url.searchParams.get('quantity'), 10);
      if (!Number.isFinite(qty) || qty <= CAP) return;
      event.preventDefault();
      event.stopPropagation();
      var row = link.closest('line-item-quantity');
      var input = row && row.querySelector('[data-line-key]');
      if (!input) return;
      input.value = String(CAP);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = cartLineInput(event.target);
      if (!input) return;
      var val = parseInt(input.value, 10);
      var max = effectiveMax(input);
      if (!Number.isFinite(val) || val <= max) return;
      event.stopImmediatePropagation();
      input.value = String(max);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    clampCartLineInputs(document);
  });
  document.addEventListener('cart:change', function () {
    clampCartLineInputs(document);
  });
  document.addEventListener('cart-drawer:refreshed', function () {
    clampCartLineInputs(document);
  });
})();
